import { render, staticRenderFns } from "./Pronunciation.vue?vue&type=template&id=261e7ea6&"
import script from "./Pronunciation.vue?vue&type=script&lang=js&"
export * from "./Pronunciation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports